<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Destination</th>
        <th>Status</th>
        <th>Packages</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(shipment, index) in shipments" :key="index">
        <td>
          <span v-if="shipment.address">
            <span v-if="shipment.address.company_name">{{ shipment.address.company_name }}<br/></span>
            {{ shipment.address.address1 }}<br>
            <span v-if="shipment.address.address2">{{ shipment.address.address2 }}<br/></span>
            {{ shipment.address.city }}, {{ shipment.address.state }} {{ shipment.address.postcode }}
          </span>
          <span v-else-if="shipment.order_mtd_company_name">
            {{ shipment.order_mtd_company_name }}
          </span>
        </td>
        <td>
          <div v-if="[6,15].includes(shipment.status)">
            <div v-if="shipment.status === 15">
              <div v-if="shipment.delivered_at">
                Delivered at: {{ moment(shipment.delivered_at).format('M/D/YY h:mm A') }}
              </div>
            </div>
            <div v-else>
              <span v-if="shipment.shipped_at">
                Shipped at: {{ moment(shipment.shipped_at).format('M/D/YY h:mm A') }}<br/>
              </span>

              <span v-if="shipment.delivery_date">
                Expected Delivery: {{ moment.utc(shipment.delivery_date).format('M/D/YY') }}<br/>
              </span>
            </div>

            <div v-if="shipment.events.length > 0">
              <strong>Last Update:</strong> {{ moment(shipment.events[0].event_date).format('M/D/YY h:mm A') }}
              {{ shipment.events[0].event_description }} {{ shipment.events[0].event_city }}, {{ shipment.events[0].event_state }}

              <button class="btn btn-outline-primary btn-sm" @click="showShippingEvents(shipment.events)">Track Package</button>

              <span v-if="shipment.tracking_number" class="d-block">
                <a :href="`https://www.fedex.com/fedextrack?trknbr=${shipment.tracking_number}`"
                   target="_blank"
                   class="d-inline-block mr-5" v-if="shipment.carrier == 'fedex'">
                  FedEx {{ shipment.tracking_number }}
                </a>
                <a :href="`http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${shipment.tracking_number}`"
                   target="_blank"
                   class="d-inline-block mr-2" v-else-if="shipment.carrier == 'ups'">
                  UPS {{ shipment.tracking_number }}
                </a>
                <span class="badge badge-secondary cursor-pointer pt-1"
                      @click="copyTrackingNumber(shipment.tracking_number)">
                  Copy
                </span>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div v-for="(box, index) in shipment.packages" :key="box.id">
            <strong class="mr-3">Package #{{ index + 1 }}</strong>
            <p class="ml-3">
              <span v-for="item in box.items">
                {{ item.qty }} x {{ item.sku }} - {{ item.name }}<br>
              </span>
            </p>
          </div>
        </td>
        <td>
          <inertia-link class="btn btn-outline-secondary"
                        :href="route('shipments.show', shipment.id)">
            <i class="fa fa-eye"></i>
          </inertia-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <ShippingEvents :defaultEvents="events" @close="events = null"></ShippingEvents>
</template>

<script>
import moment from "moment";
import ShippingEvents from '@/Components/Modals/ShippingEvents'

export default {
  components: {
    ShippingEvents,
  },
  props: {
    shipments: Array,
  },
  data() {
    return {
      events: null,
    };
  },
  created() {
    this.moment = moment
  },
  methods: {
    showShippingEvents(events) {
      this.events = events;
    },
    copyTrackingNumber(number) {
      try {
        navigator.clipboard.writeText(number);
        toastr.success('Tracking number copied to clipboard.');
      } catch (e) {
        toastr.error('Unable to access the clipboard.');
      }
    },
  }
}
</script>
